import { render, staticRenderFns } from "./EditStaffModal.vue?vue&type=template&id=789ec3e7&scoped=true&"
import script from "./EditStaffModal.vue?vue&type=script&lang=js&"
export * from "./EditStaffModal.vue?vue&type=script&lang=js&"
import style0 from "./EditStaffModal.vue?vue&type=style&index=0&id=789ec3e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789ec3e7",
  null
  
)

export default component.exports